import { render } from "./FlexWrapper.vue?vue&type=template&id=7c738e2a"
import script from "./FlexWrapper.vue?vue&type=script&lang=js"
export * from "./FlexWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__